import { render, staticRenderFns } from "./roles_permission.vue?vue&type=template&id=d6169dda&"
import script from "./roles_permission.vue?vue&type=script&lang=js&"
export * from "./roles_permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports